<template>
    <span class="billing-status-badge" :class="statusClass">
        {{ label }}
    </span>
</template>

<script>
export default {
    name: 'BillingStatusBadge',
    props: {
        status: {
            type: String,
            default: 'active',
        },
    },
    computed: {
        normalizedStatus() {
            return String(this.status || 'active').toLowerCase();
        },
        label() {
            const labels = {
                active: 'Active',
                trialing: 'Trial',
                trial: 'Trial',
                past_due: 'Past Due',
                suspended: 'Suspended',
                canceled: 'Canceled',
                cancelled: 'Cancelled',
                inactive: 'Inactive',
            };
            return labels[this.normalizedStatus] || this.status || 'Active';
        },
        statusClass() {
            return `billing-status-badge--${this.normalizedStatus.replace(
                /_/g,
                '-'
            )}`;
        },
    },
};
</script>

<style scoped>
.billing-status-badge {
    border-radius: 999px;
    display: inline-flex;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    padding: 5px 9px;
    text-transform: uppercase;
    white-space: nowrap;
}

.billing-status-badge--active,
.billing-status-badge--trialing {
    background: rgba(65, 195, 116, 0.18);
    color: #67d58a;
}

.billing-status-badge--trial {
    background: rgba(242, 189, 0, 0.2);
    color: #ffd45a;
}

.billing-status-badge--past-due,
.billing-status-badge--suspended,
.billing-status-badge--canceled,
.billing-status-badge--cancelled,
.billing-status-badge--inactive {
    background: rgba(230, 92, 102, 0.16);
    color: #ff8b92;
}
</style>
